import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosInstance, AxiosResponse } from "axios"
import { IPropsUpdatePriceCalenderBasedOnWheelhousePrice, IResponseUpdatePriceCalenderBasedOnWheelhousePrice } from "./types"
import { useApi } from "../../useApi"
import { putUpdatePriceCalenderBasedOnWheelhousePriceURL } from "../../../utils/constants"

async function putUpdatePriceCalenderBasedOnWheelhousePrice(
	responseData: IPropsUpdatePriceCalenderBasedOnWheelhousePrice,
	apiPrivate: AxiosInstance
) {
	try {
		const response: AxiosResponse<IResponseUpdatePriceCalenderBasedOnWheelhousePrice> =
			await apiPrivate.put(`${putUpdatePriceCalenderBasedOnWheelhousePriceURL}`, { ...responseData })

		return response
	} catch (error: any) {
		return error.response
	}
}

export function usePutUpdatePriceCalenderBasedOnWheelhousePrice(
	options?:
		| Omit<
				UseMutationOptions<
					AxiosResponse<IResponseUpdatePriceCalenderBasedOnWheelhousePrice>,
					unknown,
					unknown,
					AxiosResponse<IResponseUpdatePriceCalenderBasedOnWheelhousePrice>
				>,
				"mutationFn"
		  >
		| undefined
) {
	const { apiPrivate } = useApi()
	const mutation = useMutation({
		mutationFn: (data: IPropsUpdatePriceCalenderBasedOnWheelhousePrice) =>
			putUpdatePriceCalenderBasedOnWheelhousePrice(data, apiPrivate),
		...options,
	})
	return mutation
}
